export let translations = {
	// put translations in EN here
	"[[Cotton]]": "Cotton",
	"[[Polyester]]": "Polyester",
	"[[Spandex]]": "Spandex",
	"[[Other]]": "Other",
	"[[Upcycled Polyester]]": "Upcycled Polyester",
	"[[Linen]]": "Linen",
	"[[Bamboo]]": "Bamboo",
	"[[Tencel]]": "Tencel",
	"[[Rayon]]": "Rayon",
	"available": "Available",
	"soon_sold_out_coming_back": "Soon Sold Out - (Back {note})",
	"soon_sold_out_not_coming_back": "Soon Sold Out - Not Coming Back",
	"sold_out_coming_back": "Sold Out - (Back {note})",
	"sold_out_not_coming_back": "Sold Out - Not Coming Back",
	"inactive": "Inaktiv - {note}",
}